module.exports = __webpack_public_path__ + "static/logo-7a71b896ebc01882ed739f6ce0b1a017.png";